/**
 * @Author: Auto Generated
 * @Date: 2025-12-17
 * @LastEditors: Auto Generated
 * @LastEditTime: 2025-12-17
 */

import * as request from '@/utils/request'
const BASE_URL = 'paas'
export default {
  /**
   * getContractConfigList
   * @description 获取签约配置列表
   * @param {*} data
   * @returns
   */
  getContractConfigList(data) {
    return request.get(`${BASE_URL}/company/company_settlement_config`, data)
  },

  /**
   * updateContractConfig
   * @description 编辑签约配置信息
   * @param {*} id
   * @param {*} data
   * @returns
   */
  updateContractConfig(data) {
    return request.post(`${BASE_URL}/company/update_company_settlement_config`, data)
  },

  /**
   * @description 获取服务公司下的税源地
   * @author YM
   * @date 2019-01-17
   * @returns promise
   */
  getContractConfigSettlementList(data) {
    return request.get(`${BASE_URL}/company/get_settlement`, data)
  }
}
